/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Wunschsprache_English7Inputs */

const en__field__enum_wunschsprache_english7 = /** @type {(inputs: _Field__Enum_Wunschsprache_English7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const de__field__enum_wunschsprache_english7 = /** @type {(inputs: _Field__Enum_Wunschsprache_English7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englisch`)
};

/**
* | output |
* | --- |
* | "English" |
*
* @param {_Field__Enum_Wunschsprache_English7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_wunschsprache_english7 = /** @type {((inputs?: _Field__Enum_Wunschsprache_English7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Wunschsprache_English7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_wunschsprache_english7(inputs)
	return de__field__enum_wunschsprache_english7(inputs)
});
export { _field__enum_wunschsprache_english7 as "_field__enum_wunschsprache_ENGLISH" }